<template>
    <div class="my-10">
        <h1 class="font-bold text-2xl mb-5">{{ $t('nav.menu') }}</h1>
        <div class="grid grid-cols-4 gap-5 max-lg:grid-cols-3 max-md:grid-cols-2">
            <router-link v-for="item in exhibitionCategories" :key="item.id" :to="{ name: 'foodRestaurants', query: { category: item.id } }"  class="font-semibold text-lg text-gray-700 block  py-4 flex justify-between hover:text-accent-color">
            <div class="flex flex-col w-full rounded-lg shadow-md overflow-hidden">
                <div class="h-50 w-full overflow-hidden">
                    <img class="h-full w-full object-cover" :src="item.image" alt="">
                </div>
                <p class="text-center text-main-color p-4 bg-white">
                    {{ item.name }} <span v-if="item.stores_count > 0" class="text-sm text-red-500">({{ item.stores_count }})</span>
                </p>
            </div>
            </router-link>
        </div>
    </div>

</template>

<script>

export default {
    name: "foodCategories",
    computed:{
        exhibitionCategories(){
            return this.$store.exhibitionCategories
        }
    }
}

</script>